// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsApproverStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    approver?: TypographyProps;
}

export const approverStyles: OrderDetailsApproverStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
        `,
    },
};

const styles = approverStyles;

const OrderDetailsApprover = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties?.approverDisplayName || !order.properties?.approverUserName) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsApprover">
                {translate("Approver")}
            </Typography>
            <Typography
                {...styles.approver}
                aria-labelledby="orderDetailsApprover"
                data-test-selector="orderDetailsApprover"
            >
                {order.properties?.approverDisplayName} ({order.properties?.approverUserName})
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsApprover,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
